import { Loader } from 'semantic-ui-react'

import { useHelloSignBAA } from '@/shared/helloSignHelper'
import { DeviceWidth, useIsDeviceWidth } from '@/utils/deviceWidthHelpers'
import { Button, Heading, HeadingVariants, Label, Link, Text } from '@/ui'
import { TypographyStyles } from '@/styles'

export const BaaAgreements = () => {
  const { fetching, baa, openSignatureModal } = useHelloSignBAA()
  const isMobile = useIsDeviceWidth(DeviceWidth.mobile)

  if (fetching) {
    return <Loader active inline />
  }

  return (
    <>
      <Heading variant={HeadingVariants.H2} className="mb-2">
        Agreements
      </Heading>
      {baa && (
        <div className="flex items-center justify-between my-4">
          <Text>Business Associate Agreement (BAA)</Text>

          <Label color={baa.signed ? 'green' : 'red'}>
            {baa.signed ? 'Signed' : 'Unsigned'}
          </Label>

          {baa.signed ? (
            <Link href={baa.fileUrl ?? ''}>
              {isMobile ? 'Download Agreement' : 'Download'}
            </Link>
          ) : (
            <Button
              variant="link"
              className="text-brand"
              onClick={openSignatureModal}
            >
              Sign Now
            </Button>
          )}
        </div>
      )}
      {!baa && (
        <Text variant={TypographyStyles.BODY_SM}>No agreements found</Text>
      )}
    </>
  )
}
